module.exports = __webpack_public_path__ + "static/media/ppg2.d42e9cdb.jpg";